<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit Category
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Category Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !form.name"
            @click="save"
          >
            Update Category
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoryEditPage",
  data() {
    return {
      form: {
        name: "",
        subcategories: [], // Add a list of subcategories if needed
      },
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    //   this.isLoading = true;
    //   const encryptedId = this.$route.params.categoryId.sub_categoryId;

    //   if (!encryptedId) {
    //     console.error("Category ID is missing.");
    //     this.isLoading = false;
    //     return;
    //   }

    //   // Fetch category data (including subcategories if required)
    //   try {
    //     const response = await axios.get(`/categories/${encryptedId}`);
    //     this.form = response.data.data;
    //     console.log("Category data:", this.form);
    //   } catch (error) {
    //     console.error("Error fetching category data:", error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },

    async getData() {
      this.isLoading = true;
      const subcategoryId = this.$route.params.subcategoryId; // Retrieve subcategoryId

      try {
        const response = await axios.get(`/categories/${subcategoryId}`);
        this.form = response.data.data;
        console.log("Subcategory data:", this.form);
      } catch (error) {
        console.error("Error fetching subcategory data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async save() {
      this.isLoading = true;
      const subcategoryId = this.$route.params.subcategoryId; // Retrieve subcategoryId

      const categoryId = this.$route.params.categoryId; // Retrieve categoryId from the route

      // Save updated category data (including subcategories if applicable)
      try {
        await axios.patch(`/categories/${subcategoryId}`, this.form);
        this.isLoading = false;
        this.$router.push(`/categories/${categoryId}/sub-categories`); // Redirect to category list after saving
      } catch (error) {
        console.error("Error updating category:", error);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  padding: 20px;
}
</style>
